/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const FaceSmile = ({ className }) => {
  return (
    <svg
      className={`face-smile ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="g" clipPath="url(#clip0_2_8994)">
        <path
          className="path"
          d="M6.66669 11.6667C6.66669 11.6667 7.91669 13.3333 10 13.3333C12.0834 13.3333 13.3334 11.6667 13.3334 11.6667M12.5 7.49999H12.5084M7.50002 7.49999H7.50835M18.3334 9.99999C18.3334 14.6024 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6024 1.66669 9.99999C1.66669 5.39762 5.39765 1.66666 10 1.66666C14.6024 1.66666 18.3334 5.39762 18.3334 9.99999ZM12.9167 7.49999C12.9167 7.73011 12.7301 7.91666 12.5 7.91666C12.2699 7.91666 12.0834 7.73011 12.0834 7.49999C12.0834 7.26987 12.2699 7.08332 12.5 7.08332C12.7301 7.08332 12.9167 7.26987 12.9167 7.49999ZM7.91669 7.49999C7.91669 7.73011 7.73014 7.91666 7.50002 7.91666C7.2699 7.91666 7.08335 7.73011 7.08335 7.49999C7.08335 7.26987 7.2699 7.08332 7.50002 7.08332C7.73014 7.08332 7.91669 7.26987 7.91669 7.49999Z"
          stroke="#175CD3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <defs className="defs">
        <clipPath className="clip-path" id="clip0_2_8994">
          <rect className="rect" fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
};
